import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import UserLogLayer from "../components/UserLogLayer";

const UserLogPage = () => {
    return (
        <MasterLayout>
            <UserLogLayer />
        </MasterLayout>
    );
};

export default UserLogPage;
